(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.api.persona
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.tema', [

    ]);
}());
